"use client";
import r from "styled-components";
import "react";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import "./index.es16.js";
import "./index.es17.js";
import o from "./index.es62.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
const t = "stat-monitor-indicator-table-indicator-name", i = "stat-monitor-indicator-table-value", a = "stat-monitor-indicator-table-spread", T = r.table`
  min-width: 800px;
  caption {
    height: 0;
    overflow: hidden;
    display: block;
  }

  ${o.mediaQueries["bl-handset-down"]} {
    tbody {
      td.${t} {
        max-width: 100px;
      }
      td.${i} {
        width: 70px;
      }
    }
  }

  ${o.mediaQueries["bl-handset-large-up"]} {
    min-width: 100%;
  }

  thead {
    vertical-align: bottom;
    th {
      padding: 0.25rem;
      font-weight: normal;
      text-align: left;
    }
  }
  tbody {
    tr {
      border-top: 1px solid;
      border-bottom: 1px solid;

      td,
      th {
        background-color: #fff;
        padding: 0.5rem;
        &:not(:last-child) {
          border-right: 1px solid;
        }
        &.${t} {
          vertical-align: top;
          text-align: left;
        }
        &.${i} {
          text-align: right;

          white-space: nowrap;
        }
        &.${a} {
          padding: 0 12px 0 12px;
        }
      }
    }
    tr:nth-child(even) {
      td:not(.${t}) {
        background-color: #f2f1ed;
      }
    }
  }
`;
export {
  T as default,
  t as indicatorNameClass,
  a as indicatorSpreadClass,
  i as indicatorValueClass
};
//# sourceMappingURL=index.es80.js.map
